import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const NumberContainer = styled(Box)(({ theme }) => ({
  marginRight: theme.spacing(3),
  "div:first-of-type": {
    marginRight: theme.spacing(3),
  },
}));
